import { getToken } from "../cookie/authCookie";
import axiosInstance from "./config/axiosConfigs";

export const SubscriptionAPI = {
  getSubscriptionDetail: async function ( userId, clubId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/userId/${userId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      // timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  getSubscriptionDetailFromStripe: async function (subscriptionId,userId, clubId) {
    const response = await axiosInstance.request({
      url: `/platform/${subscriptionId}/user/${userId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  findSubscription: async function (clubId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/user/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  isSubscriptionPurchased: async function ( userId, clubId) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/is-subscription-purchased/user/${userId}/club/${clubId}`,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },


  postPurchasePlan: async function (createProductInfo) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/create`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: createProductInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postPurchasePayAsYouGoPlan: async function (reqData) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/pay_as_you_go/create`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: reqData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postPurchaseFreeCoachPlan: async function (reqData) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/coach/create`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: reqData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  postCancelPayAsYouGoPlan: async function (reqData) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/pay_as_you_go/cancel`,
      method: "POST",
      withCredentials: true,
      timeout: 20000,
      data: reqData,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  getClubSubscriptionsWithPlatform: async function (status, userId, clubId) {

    const response = await axiosInstance.request({
      url: `/platform/subscription/status/` + status + "/userId/" + userId + "/club/" + clubId,
      method: "GET",
      withCredentials: true,
      timeout: 5000,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  // postSaveSubscription: async function (subscriptionInfo) {
  //   const response = await axiosInstance.request({
  //     url: `/ecommerce/subscription/save`,
  //     method: "POST",
  //     withCredentials: true,
  //     timeout: 5000,
  //     data: subscriptionInfo,
  //     headers: { Authorization: `Bearer ${getToken()}` },
  //   });
  //   return response.data;
  // },

  deleteSubscription: async function (cancelSubscriptionInfo, isRefundAll) {
    cancelSubscriptionInfo.isRefundAll = isRefundAll
 
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/cancel`,
      method: "DELETE",
      withCredentials: true,
      // timeout: 5000,
      data: cancelSubscriptionInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  updateSubscription: async function (updateSubscription) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/update`,
      method: "POST",
      withCredentials: true,
      timeout: 5000,
      data: updateSubscription,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
  resumeSubscription: async function (updateSubscription) {
    const response = await axiosInstance.request({
      url: `/ecommerce/subscription/resume`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000,
      data: updateSubscription,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },
};